"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommandWrapper = void 0;

var stringify_1 = require("../../../utils/stringify");

var symbols_1 = require("../../symbols");

var CommandWrapper = /*#__PURE__*/function () {
  function CommandWrapper(cmd) {
    _classCallCheck(this, CommandWrapper);

    this.cmd = cmd;
    this.hasRan = false;

    if ((0, stringify_1.hasToStringMethod)(cmd)) {
      var method = cmd[stringify_1.toStringMethod];

      this[stringify_1.toStringMethod] = function toStringMethod() {
        return method.call(cmd);
      };
    }

    if ((0, stringify_1.hasAsyncToStringMethod)(cmd)) {
      var _method = cmd[stringify_1.asyncToStringMethod];

      this[stringify_1.asyncToStringMethod] = function asyncToStringMethod() {
        return _method.call(cmd);
      };
    }
  }

  _createClass(CommandWrapper, [{
    key: "check",
    value: function check(m) {
      return this.cmd.check(m);
    }
  }, {
    key: "run",
    value: function run(m, r) {
      this.hasRan = true;
      return this.cmd.run(m, r);
    }
  }, {
    key: "clone",
    value: function clone() {
      if ((0, symbols_1.hasCloneMethod)(this.cmd)) return new CommandWrapper(this.cmd[symbols_1.cloneMethod]());
      return new CommandWrapper(this.cmd);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.cmd.toString();
    }
  }]);

  return CommandWrapper;
}();

exports.CommandWrapper = CommandWrapper;